<template>
    <MyModal
        :wrapperClass="'--ask-specialist'"
        :name="modalName"
        :title="renderDynamicModalField('title', $t('modalAskSpecialistTitle'))"
    >
        <div class="form">
            <dov class="form__title" v-html="renderDynamicModalField('description', $t('modalAskSpecialistFormTitle'))" />
            <div class="form__inputs">
                <MyInput
                    :labelText="$t('modalAskSpecialistFormInputNameLabel')"
                    type="text"
                    :value="form.name"
                    :isUnvalid="getSubmited && $v.form.name.$invalid"
                    @input="e => changeInput(e, 'name')"
                />
            </div>

            <div class="form__inputs">
                <MyInput
                    :labelText="this.$t('modalAskSpecialistFormInputPhoneLabel')"
                    type="tel"
                    :value="form.phone"
                    @get-number-count="getNumberCount"
                    :isUnvalid="getSubmited && $v.form.phone.$invalid"
                    @input="e => changeInput(e, 'phone')"
                />
            </div>

            <MyActionBtn
                :disabled="isLoadingSubmit"
                class="form__button"
                :btnText="renderDynamicModalField('button_label', $t('modalAskSpecialistFormSubmit'))"
                :icon="'arrowRightIcon'"
                :size="currentBtnSize"
                btnType="submit"
                @click="handleSave"
            />
        </div>
    </MyModal>
</template>

<script>
import eventBus from '@/plugins/event-bus';
import { required, minLength } from 'vuelidate/lib/validators';
import { MODAL_ASK_SPECIALIST } from '~/themes/novaporta/consts/modals';
import phoneCount from '~/mixins/phone-validation-count';

import viewport from '@/mixins/viewport';

import dynamicModal from '~/mixins/dynamicModal';
import { MODAL_ASK_SPECIALIST_NOVAPORTA } from '~/consts/modals';

const initialFormState = {
    name: '',
    phone: ''
};

export default {
    name: 'ModalAskSpecialist',
    mixins: [phoneCount, viewport, dynamicModal],
    data() {
        return {
            dynamicModalName: MODAL_ASK_SPECIALIST_NOVAPORTA,
            modalName: MODAL_ASK_SPECIALIST,
            form: {
                name: '',
                phone: ''
            },
            getSubmited: false,
            isLoadingSubmit: false
        };
    },
    computed: {
        currentBtnSize() {
            return this.isUnderOrEqualViewport1024 === true ? 'medium' : 'medium';
        }
    },
    components: {
        MyModal: () => import('@/themes/novaporta/components/ui/MyModal'),
        MyInput: () => import('@/themes/novaporta/components/ui/MyInput'),
        MyActionBtn: () => import('@/themes/novaporta/components/ui/MyActionBtn'),
        AskUs: () => import('@/themes/novaporta/components/reusable/AskUs')
    },
    validations() {
        const baseValidations = {
            name: { required },
            phone: { required, minLength: minLength(this.phoneMinlength) }
        };

        return {
            form: baseValidations
        };
    },
    methods: {
        changeInput(e, name) {
            this.form[name] = e;
        },
        resetForm() {
            this.form = { ...initialFormState };
            this.getSubmited = false;
            this.$v.$reset();
        },
        sendSuccessNotification() {
            eventBus.$emit('show-toast', {
                message: this.$t('globalTextAttributeRequestMessageSuccess'),
                type: 'success'
            });
        },
        sendErrorNotification() {
            eventBus.$emit('show-toast', {
                message: this.$t('globalTextAttributeRequestMessageFailed'),
                type: 'failure'
            });
        },
        async handleSave() {
            this.getSubmited = true;

            this.$v.form.$touch();

            if (this.$v.form.$invalid) {
                return;
            }

            this.isLoadingSubmit = true;

            try {
                await this.$api.home.postBookConsultation({
                    ...this.form,
                    request_purpose: 'ask_specialist'
                });
                this.$store.dispatch('global/close');
                this.sendSuccessNotification();
                this.resetForm();
            } catch (e) {
                console.error(e);
                this.sendErrorNotification();
            } finally {
                this.isLoadingSubmit = false;
            }
        }
    }
};
</script>

<style lang="scss">
@import './styles.scss';
</style>
